"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const Common_1 = require("./Common");
const TGLabelWrapper_1 = __importDefault(require("./TGLabelWrapper"));
const TGTextField = (props) => {
    const { readOnly, warning, computed } = props;
    const classes = (0, Common_1.useStyles)();
    const [tooltip, setTooltip] = (0, react_1.useState)(false);
    const label = (react_1.default.createElement(TGLabelWrapper_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, tooltip: tooltip, calculated: computed }));
    return (react_1.default.createElement(core_1.TextField, Object.assign({ fullWidth: true, InputLabelProps: {
            shrink: true,
            className: (0, clsx_1.default)(classes.labelShrink, warning && classes.warningText),
        } }, props, { label: label, className: classes.formElementWrapper, InputProps: {
            readOnly,
            disabled: readOnly,
            className: (0, clsx_1.default)(warning && classes.warningBorderBottom),
        }, FormHelperTextProps: { className: (0, clsx_1.default)(warning && classes.warningText) }, required: false, 
        // We want the Tooltip to be triggered on field hovering, but positionned relative to the label
        onMouseEnter: () => readOnly && setTooltip(true), onMouseLeave: () => readOnly && setTooltip(false) })));
};
exports.default = TGTextField;
//# sourceMappingURL=TGTextField.js.map